import type { PanelUnitProps } from '@frameio/vapor';

export const MEDIUM_NAV_MIN_WIDTH = 160;
export const MEDIUM_NAV_DEFAULT_WIDTH = 200;
export const MEDIUM_NAV_MAX_WIDTH = 440;
export const LARGE_NAV_DEFAULT_WIDTH = 280;

/** Min width for the ProjectNavigation panel (directoryNav). */
export const PROJECT_NAV_MIN_WIDTH = 224;
export const PROJECT_NAV_MIN_WIDTH_COMPACT = 180;

/* Enforce a min width to prevent annotation tools from going to two lines. */
export const DETAILS_MIN_WIDTH = 342;
export const DETAILS_DEFAULT_WIDTH = 376;

/**
 * Row minimums for the stacked (base/mobile) viewer layout. Sized so the
 * comment composer and tab bar remain reachable when the viewport is short
 * (e.g. 200% browser zoom on a 1366×768 display) — WCAG 1.4.4.
 *
 * Details floor = tabs (~40) + composer min-height (87) ≈ 127 → 130 with a
 * small slack buffer. This lets the user drag the resizer down to give the
 * viewer more room; at the floor the Filters bar visually overlaps the
 * composer, which is an accepted trade-off for the user's explicit choice
 * to compress the panel. Viewer floor is just enough room for the player's
 * bottom control bar.
 */
export const DETAILS_ROW_MIN_HEIGHT_BASE = 130;
export const VIEWER_ROW_MIN_HEIGHT_BASE = 80;

/** Share review header panel size, needs to be hard coded in all sizes to prevent issues */
export const SHARE_REVIEW_HEADER_PANEL_PROPS: PanelUnitProps = {
  defaultMin: 50,
  defaultSize: 50,
  defaultMax: 50,
};

export const AI_DEFAULT_MIN_WIDTH = 316;
export const AI_DEFAULT_MIN_WIDTH_COMPACT = 260;
export const AI_DEFAULT_WIDTH = 400;
